import PlayerScoreTable from "../../players/tables/PlayerScoreTable";
import {useTranslation} from "react-i18next";
import {GenericInput} from "../../common/GenericInput";
import {useTournament} from "../../../hooks/queries/useTournament";
import type {Match, PlayerScore} from "../../../types/domain";

interface GroupsOverviewTabProps {
  round: number;
  tournamentId: number;
  isActive: boolean;
}

interface GroupData {
  group: number | null | undefined;
  playerIds: number[];
  scores: PlayerScore[];
  matches: Match[];
}

function GroupsOverviewTab(props: GroupsOverviewTabProps) {
  const { t } = useTranslation();
  const { data: tournament } = useTournament(props.tournamentId, {
    refetchInterval: props.isActive ? 30_000 : false,
  });

  if (!tournament) {
    return null;
  }

  const round = tournament.rounds[props.round]

  const playerSecondGroupMap = new Map(
    tournament.players.map(player => [player.player.id, player.secondRoundGroup])
  )
  round.scores.forEach(score => {
    if (playerSecondGroupMap.has(score.player.id)) {
      score.player.secondRoundGroup = playerSecondGroupMap.get(score.player.id)
    }
  })

  const groupOptions = [...new Set(tournament.players.map(player =>
    round.roundOrder === 1 ? player.firstRoundGroup : player.secondRoundGroup
  ))].sort()
  const groups: GroupData[] = groupOptions.map(group => {
    const playerIds = tournament.players
      .filter(player => (round.roundOrder === 1 ? player.firstRoundGroup : player.secondRoundGroup) === group)
      .map(p => p.player.id);
    return {
      group,
      playerIds,
      scores: round.scores.filter(score => playerIds.includes(score.player.id)),
      matches: round.matches.filter(match => playerIds.includes(match.playerOne.id) || playerIds.includes(match.playerTwo.id)),
    };
  });

  return (
    <div className="d-flex flex-wrap mt-3 column-gap-5">
      {groups.map(groupData => {
        return (
          <div className="groups-overview-group-column" key={"round-" + props.round + "-group-" + groupData.group}>
            <div className="d-flex justify-content-between">
              <h5>{t("group")} {groupData.group}</h5>
              <GenericInput id={`tournament-overview-tab-round-${round.id}-group-${groupData.group}-note`} />
            </div>
            <PlayerScoreTable scores={groupData.scores} tournamentId={props.tournamentId} hideBuchholz={true} hideElo={true} />
          </div>
        )
      })}
    </div>
  )
}

export default GroupsOverviewTab
